import React from "react";
import TextInput from "./TextInput";
import Button from "./Button";
import moment from "moment";
import MyDatePickerBilling from "./DatePickerBillings";

export default class RataStatusWidgetCorso extends React.Component {
	constructor(props) {
		super(props);

		this.rataDateRef = React.createRef();
		this.importoRef = React.createRef();

		// Salviamo localmente i campi che ci interessano
		this.state = {
			mese: props.rata?.mese || "",
			importo: props.rata?.importo || "",
			dataRata: props.rata?.data || "",
		};
	}

	componentDidUpdate(prevProps) {
		// Se la props.rata è cambiata, aggiorniamo lo stato locale
		if (JSON.stringify(prevProps.rata) !== JSON.stringify(this.props.rata)) {
			this.setState({
				mese: this.props.rata?.mese || "",
				importo: this.props.rata?.importo || "",
				dataRata: this.props.rata?.data || "",
			});
		}
	}

	render() {
		if (!this.props.rata) return null;

		// Se la data "DD-MM-YYYY" è valida, la convertiamo in "YYYY-MM-DD"
		// altrimenti passiamo null (così MyDatePicker non va in errore)
		let dataPerPicker = null;
		const mom = moment(this.state.dataRata, "DD-MM-YYYY");
		if (mom.isValid()) {
			dataPerPicker = mom.format("YYYY-MM-DD");
		}

		return (
			<div style={{ display: this.props.show ? "block" : "none" }}>
				<div style={container}>
					<div style={mainClass}>
						<div
							style={closeBtn}
							onClick={() => {
								this.props.onClose();
							}}
						>
							X
						</div>

						<div>
							<label>Data rata:</label>
							<MyDatePickerBilling
								value={dataPerPicker}
								onChange={nuovaStringa => {
									if (nuovaStringa) {
										this.setState({
											dataRata: moment(nuovaStringa, "YYYY-MM-DD").format("DD-MM-YYYY"),
										});
									} else {
										this.setState({ dataRata: "" });
									}
								}}
							/>
						</div>

						<TextInput
							name="Importo"
							value={this.state.importo}
							onChange={val => this.setState({ importo: val })}
						/>

						{/* Nuovo input per il Mese di riferimento */}
						<TextInput
							name="Mese di riferimento"
							value={this.state.mese}
							onChange={val => this.setState({ mese: val })}
						/>

						<Button
							title="SALVA"
							callback={() => {
								// Creiamo un oggetto rataAggiornata
								const rataAggiornata = {
									...this.props.rata,
									data: this.state.dataRata, // "DD-MM-YYYY"
									importo: this.state.importo,
									mese: this.state.mese,
								};
								this.props.onClose(rataAggiornata);
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const mainClass = {
	position: "fixed",
	top: "25%",
	left: "25%",
	width: "50%",
	border: "1px solid black",
	background: "#ffffff",
	padding: "2%",
	height: "400px",
	overflow: "scroll",
};

const container = {
	position: "fixed",
	width: "100%",
	height: "100%",
	top: 0,
	left: 0,
	background: "#ffffff88",
	zIndex: 999,
};

const closeBtn = {
	position: "absolute",
	right: "1%",
	top: "1%",
	cursor: "pointer",
};
